import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/per.png'
import _imports_1 from '../assets/psd.png'


const _hoisted_1 = { class: "Login" }
const _hoisted_2 = { class: "LoginBox" }
const _hoisted_3 = { class: "BoxLes" }
const _hoisted_4 = { class: "LesCons" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "欢迎登录", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("span", null, "同步仓库管理"),
  /*#__PURE__*/_createTextVNode("系统")
], -1)
const _hoisted_7 = { class: "LesForm" }
const _hoisted_8 = { class: "Lis" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "Icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_10 = { class: "Lis" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "Icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)

import { reactive, ref } from 'vue'
  import { useAlone } from '@/store';
  import pinia from '@/store/store';
  import {useRouter} from 'vue-router'
  import api from '@/api/index'
  import { ElMessage, ElLoading, FormInstance, FormRules } from 'element-plus'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

  const alone = useAlone(pinia)
  const router = useRouter()
  
  const ruleFormRef = ref<FormInstance>()
  const rules = reactive<FormRules>({
    username: [
      { required: true, message: '请输入用户名', trigger: 'blur' },
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
    ],
  })

  const swiperCons = reactive([
    require("../assets/lb1.jpg"),
    require("../assets/lb2.jpg"),
    require("../assets/lb3.jpg"),
    require("../assets/lb4.jpg")
  ]);
  
  const ruleForm = reactive({
    username:'',
    password:'',
  });
  const login = (formName:any) => {
    const loading = ElLoading.service({
      lock: true,
    })
    api.aloneApi.login(ruleForm).then((res:any) => {
        if (res.code === 200) {
            localStorage.setItem('userId', res.data.id)
            localStorage.setItem('username', ruleForm.username)
            alone.setLoginStatus(true)
            setTimeout(() => {
              router.push("/setting");
              ElMessage({
                message: res.message,
                type: 'success',
              })
              loading.close()
            }, 1000)
        } else if (res.code == 1002) {
          alone.setLoginStatus(true)
          // 当前已经登录
          router.push({path: '/setting'})
        }else{
          setTimeout(() => {
            loading.close()
            ElMessage.error(res.message)
          }, 1000)
        }
    }).catch((res:any) => {
      loading.close()
      ElMessage.error(res.message);
    })
  }
  
return (_ctx: any,_cache: any) => {
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.username) = $event)),
                    placeholder: "请输入账号"
                  }, null, 512), [
                    [_vModelText, ruleForm.username]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.password) = $event)),
                    placeholder: "请输入密码"
                  }, null, 512), [
                    [_vModelText, ruleForm.password]
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "Sign",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (login('ruleForm')))
              }, "登录")
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})